import { DesignData } from 'src/store/design/types';

const hasEmbroideryWarnings = (designData?: DesignData): boolean => {
  if (!designData?.warnings) {
    return false;
  }
  return designData.warnings.some(
    (w) => w.type === 'MaxStitchCount' || w.type === 'MaxColorCount',
  );
};

export default hasEmbroideryWarnings;
